var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home fullscreen"},[(_vm.marketDays[_vm.settings.dateOptions.day] && _vm.globoSchedule.globoSchedules.length > 0 && _vm.market.markets.length > 0)?_c('RouterView'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }